module.exports = __webpack_public_path__ + "static/media/14.34c69dd0.jpg";